var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBatteryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 4,
    fill: "#FFCC00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.625 8.52493H17.1598V7.46563C17.1598 6.68353 16.5262 6.04993 15.7441 6.04993H4.7155C3.9334 6.04993 3.2998 6.68353 3.2998 7.46563V14.5342C3.2998 15.3163 3.9334 15.9499 4.7155 15.9499H15.7441C16.5262 15.9499 17.1598 15.3163 17.1598 14.5342V13.4749H18.625C18.9022 13.4749 19.1398 13.2769 19.1398 13.0294V8.97043C19.1398 8.72293 18.9121 8.52493 18.625 8.52493ZM16.1104 14.5342C16.1104 14.7421 15.9421 14.9104 15.7342 14.9104H4.7155C4.5076 14.9104 4.3393 14.7421 4.3393 14.5342V7.46563C4.3393 7.25773 4.5076 7.08943 4.7155 7.08943H15.7441C15.952 7.08943 16.1203 7.25773 16.1203 7.46563V14.5342H16.1104Z",
    fill: "#061A42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6849 8.52502H5.7749V13.475H14.6849V8.52502Z",
    fill: "#061A42"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryIcon);
export default __webpack_public_path__ + "static/media/batteryIcon.c11d79699133c3a3e35fc9fecd6c8528.svg";
export { ForwardRef as ReactComponent };